import React from "react"
import { graphql } from "gatsby"

import RichText from "../RichText"

import { CopyModel } from "../../models/components"

interface CopyProps extends CopyModel {
  cssClass?: string
  pageContext: any
}

const defaultProps = {}

export const Copy: React.FC<CopyProps> = props => {
  if (!props.content) return null

  return (
    <RichText
      content={props.content}
      cssClass={`embed ${props.cssClass || ""}`}
      pageContext={props.pageContext}
    />
  )
}

Copy.defaultProps = defaultProps

export default Copy

/******************************************************
	Data
******************************************************/
export const query = graphql`
  fragment CopyFields on Contentstack_copy {
    id
    content
    internal {
      type
    }
  }
`
